import { Component } from 'react';
import { Field } from 'redux-form';

import { GroupControl } from '../../../GroupField';
import PriceControl from '../Control';

export default class PriceGroupField extends Component {
  render() {
    return (
      <Field
        {...this.props}
        component={GroupControl}
        FormControl={PriceControl}
      />
    );
  }
}
